export default class VoteModalDOM {
    constructor() {
        this._init();
    }

    setup(settings) {
        this.settings = settings;
        this._setContent();
    }

    _init() {
        this.$series = document.querySelector(".js-vmodal__series");
        this.$title = document.querySelector(".js-vmodal__title span");
        this.$text = document.querySelector(".js-vmodal__text span");
        this.imageList = [...document.querySelectorAll(".js-vmodal__img")];
        this.settings = {};
    }

    _setContent() {
        this.imageList.forEach(($image) => {
            $image.setAttribute("src", this.settings.image);
        });

        let series_str = this.settings.sholder != "" ? `${this.settings.sholder} ` : "";

        if (this.settings.key != "extra") {
            this.$series.innerHTML = `${series_str + this.settings.series} #${this.settings.storyNo}`;
        } else {
            this.$series.innerHTML = `${series_str + this.settings.series}`;
        }

        if (this.settings.title != "") {
            this.$title.innerHTML = `「${this.settings.title}」`;
            document.querySelector(".js-vmodal__title p").style.display = "inline-block";
        } else {
            this.$title.innerHTML = "";
            document.querySelector(".js-vmodal__title p").style.display = "none";
        }

        this.$text.innerHTML = this.settings.text;
        this.$text.classList.add("-close");
    }
}
